export default class StickyHeader {
    constructor(props) {
        let self = this;

        this.stickyAfterSelector = props.stickyAfterSelector;
        this.stickySelector = props.stickySelector;
        this.$stickyAfterBlock = $(this.stickyAfterSelector);
        this.$stickyBlock = $(this.stickySelector);
        this.marginTop = $('html').css('marginTop');
        this.stickyAfter = this.$stickyAfterBlock.length ? this.$stickyAfterBlock.outerHeight() : 0;

        if(this.$stickyAfterBlock.length) {
            $(window).on('load resize', function (e) {
                if(e.type === 'resize') {
                    self.marginTop = $('html').css('marginTop');
                    this.stickyAfter = self.$stickyAfterBlock.length ? self.$stickyAfterBlock.outerHeight() : 0;
                }

                self.call();
            }).on('scroll', function (e) {
                self.call();
            });
        }else {
            console.warn('The stickySelector: ${this.stickyAfterSelector} was not found.');
        }
    }

    call() {
        let scrollPosition = $(window).scrollTop();

        if(scrollPosition > this.stickyAfter) {
            this.$stickyBlock.addClass('fixed');

            if(this.marginTop.length) {
                this.$stickyBlock.children().css({
                    'top': this.marginTop
                });
            }
        }else {
            this.$stickyBlock.removeClass('fixed');
            this.$stickyBlock.children().removeAttr('style');
        }
    }
}